<template>
  <div>
    <base-header class="pb-4" />

    <div class="container-fluid mt--4 pt-5 income-forms">
      <b-row>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">Tarih <span style="color:red">*</span></legend>
            <b-form-input v-model="expense.first_payment_date" type="date" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">Son Ödeme Tarihi <span style="color:red">*</span></legend>
            <b-form-input type="date" v-model="expense.last_payment_date" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">Kategori <span style="color:red">*</span></legend>
            <b-form-select v-model="expense.category_id" :options="categories" />
          </b-form-group>
        </b-col>
        <b-col>
          <b-form-group>
            <legend tabindex="-1" class="bv-no-focus-ring col-form-label pt-0">Fiyat <span style="color:red">*</span></legend>
            <b-form-input v-model="expense.price" type="number" />
          </b-form-group>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col class="text-right">
          <b-button @click="hideModal()" variant="secondary">İptal</b-button>
          <b-button variant="primary" class="loading-button" @click="saveDebt" :disabled="$v.$invalid || loadingButton">
            <i v-if="loadingButton" class="fa fa-spinner"></i> Kaydet</b-button>
        </b-col>
      </b-row>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'
  import { required } from 'vuelidate/lib/validators'
  export default {
    name: 'ExpenseModal',
    props: ['show', 'categories', 'clientId'],
    data() {
      return {
        loadingButton: false,
        expense: {},
      }
    },
    methods: {
      ...mapActions(['updateDebt', 'createDebt']),
      saveDebt() {
        this.loadingButton = true;
        // create
        this.createDebt({
          ...this.expense,
          client_id: this.clientId,
        }).then(() => {
          this.loadingButton = false;
          this.$emit('refresh-table');
          this.$refs.debtModal.hide();
        }).catch(error => {
          this.loadingButton = false;
          this.error(error.response.data.message);
        });
      },
      hideModal() {
        this.$emit('hide');
      },
    },
    validations() {
      const data = {};
      data.expense = {};
      data.expense.first_payment_date = { required };
      data.expense.last_payment_date = { required };
      data.expense.category_id = { required }
      data.expense.price = { required }
      return data;
    },
  }
</script>
